/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:ccQuestionariSrvc
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsQuestionariSrvc', [
    '$http',
    'TLPS_CONSTANTS',
    function($http, CONSTANTS) {
      this.$http = $http;

      var self = this;

      /**
       * @ngdoc method
       * @name promiseDettaglioQuestionario
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli della pratica
       * @return {Promise} - Ritorna una promise contenente i dettagli della pratica
       */
      this.promiseDettaglioQuestionario = function(lingua, settore) {
        // this.spinner.pratica = true;
        var qryParams = {};
        if (settore && lingua) {
          qryParams.settore = settore;
          qryParams.lingua = lingua;
        }

        return self.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.QUESTIONARI.RECUPERA_QUESTIONARI,
          params: qryParams
        });
      };
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsProposta/tlpsQuestionari/tlpsQuestionariSrvc.js
// module id = 36
// module chunks = 0